import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http, util } from "../../../_helpers";
import { appConstants } from "../../../_constants";
const { string } = util;

export * from "./show";
export * from "./edit";
declare var $: any;
let fetching = false;
let tab: any = null;
export const AdminCompanies = () => {
  const navigate = useNavigate();
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<any[]>([]);

  const getItems = () => {
    if (fetching) return;
    fetching = true;
    console.log("CHARGER LES COMPANIES");

    http.get('/public/companies/list').then((res) => {
    console.log("CHARGEMEMENT DES COMPANIES",res);

      if (Array.isArray(res?.data)) {
        setItems(res.data);
        setTimeout(() => {
          if (($ as any).fn.DataTable.isDataTable($(ref.current) as any)) {
            if (tab) {
              tab.clear();
              tab.destroy();
            }
            $(ref.current).empty();
          }
          tab = ($(ref.current) as any).DataTable(
            appConstants.dataTableSettings
          );
        }, 400);
      }
      setLoading(false);
      fetching = false;
    });
  };

  const onShow = (state: any) => {
    navigate("show", { state });
  };

  const onStatus = async (state: any) => {
    const active = state.active == "1" ? "0" : "1";
    if (active == "0") {
      if (
        !window.confirm(
          `Attention ! vous êtes sur le point de désactiver la companie ${state.name}.`
        )
      ) {
        return;
      }
    }
    setLoading(true);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
    const res = await http.post(
      encodeURI(`/companies/admin/update`),
      { ...state, active }
    );
    if (res.code === 200) {
      window.location.reload();
    } else {
      alert("Une erreur est survenue ! Merci de reéssayer.");
      setLoading(false);
    }
  };

  const onEdit = (state: any) => {
    navigate("edit", { state });
  };

  const onDelete = async (state: any) => {
    const superadmin = await util.amIAdmin();
    if(!superadmin){ 
      alert("L'administrateur doit être un super administrateur pour pouvoir supprimer une companie!");
      return;
    }
    let v = window.confirm(
      ` Attention vous êtes sur le point de supprimer la compagnie dont le nom est ${state.company_name}. Cette action est irreversible !`
    );
    if (v) {
      setLoading(true);
      await http.remove(encodeURI(`/companies/admin/delete/${state.uuid}`));
      getItems();
    }
  };

  useEffect(() => {
    getItems();
  }, []);
  return (
    <div>
      <h4 className="text-muted mb-4">Gestion des compagnies </h4>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card border-0 rounded-0">
            <div className="card-title mb-1 p-3">
              {!loading && <h5>Liste des compagnies</h5>}
              {loading && <h5 className="text-muted">Chargement en cours</h5>}
            </div>
            <div className="card-body">
              {!loading && (
                <div className="table-responsive-md">
                  <table
                    id="admin_table"
                    ref={ref}
                    className="table table-hover"
                  >
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nom</th>
                        <th scope="col">Adresse</th>
                        <th scope="col">Téléphone</th>
                        <th scope="col">Email</th>
                        <th scope="col">Status</th>
                        <th scope="col">Catégorie</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, i) => {
                        return (
                          <tr key={i}>
                            <th scope="row">{i + 1}</th>
                            <td>{string(item.name)}</td>
                            <td>{string(item._address)}</td>
                            <td>{string(item._phoneNumber)}</td>
                            <td>{string(item._email)}</td>
                            <td className="text-center">
                              {item.active == "1"  && (
                                <i
                                  className="fa fa-check text-success"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onStatus(item)}
                                ></i>
                              )}
                              {item.active == "0" && (
                                <i
                                  className="fa fa-times text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onStatus(item)}
                                ></i>
                              )}
                            </td>
                            <td>{string(item._type)}</td>
                            <td>
                              <a
                                className="btn btn-sm btn-outline-lightning rounded-0 mr-2 "
                                onClick={() => onShow(item)}
                              >
                                <i className="fa fa-eye"></i>
                              </a>
                              <a
                                className="btn btn-sm btn-outline-lightning rounded-0 mr-2 "
                                onClick={() => onEdit(item)}
                              >
                                <i className="far fa-edit"></i>
                              </a>
                              <a
                                className="btn btn-sm btn-outline-lightning rounded-0"
                                onClick={() => onDelete(item)}
                              >
                                <i className="far fa-trash-alt"></i>
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
